/** рассчитывает текст, который будет в итоге проставлен в элемент */
export var checkOptionText = function checkOptionText(_ref) {
  var label = _ref.label,
    activeOptions = _ref.activeOptions,
    isToggle = _ref.isToggle;
  var allTexts = label || '';
  if (Array.isArray(activeOptions) && activeOptions[0].id !== '' && isToggle) {
    allTexts = activeOptions[0].label ? activeOptions[0].label : '';
  }
  return allTexts;
};